import React from "react";
import CustomCard from "../../../../components/custom-card/custom-card";
import GradientButton from "../../../../components/gradient-tick-button/gradient-tick-button";
import CustomPieChart from "../../../../components/custom-piechart/custom-piechart";
import styles from "./gender-distribution.module.css";

const COLOUR_MAP = {
  Male: "#569BF6",
  Female: "#7F56D9",
};

const GenderDistributionCard = ({ genderDetails = [] }) => {
  const processedData = genderDetails.map((item) => {
    return {
      name: item.student_type,
      percentage: item.percentage,
      count: item.student_count,
      colour_code: COLOUR_MAP[item.student_type] || "#CCCCCC",
    };
  });

  const totalStudents = processedData.reduce(
    (sum, d) => sum + Number(d.count || 0),
    0
  );

  return (
    <CustomCard className={styles.genderCard}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          columnGap: 7,
        }}
      >
        <div className={styles.card_container}>
          <span className={styles.card_heading}>
            Students Gender Distribution
          </span>
        </div>
        <div style={{ marginLeft: "auto" }}>
          <GradientButton />
        </div>
      </div>

      <div className={styles.chartStatsWrapper}>
        <CustomPieChart
          data={processedData}
          labelText="Total Students"
          labelValue={totalStudents}
        />

        <div className={styles.statsList}>
          {processedData.map((entry, idx) => {
            return (
              <div key={idx} className={styles.statsItem}>
                <div
                  style={{
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                    backgroundColor: entry.colour_code,
                  }}
                />

                <div>{entry.name}</div>
                <span className={styles.countValue}>
                  {entry.count} Students ({entry.percentage}%)
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </CustomCard>
  );
};

export default GenderDistributionCard;
